import script from "./Docs.vue?vue&type=script&setup=true&lang=ts"
export * from "./Docs.vue?vue&type=script&setup=true&lang=ts"

import "./Docs.vue?vue&type=style&index=0&id=682c4a1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-682c4a1f"]])

export default __exports__